function SectionJobLocation() {
    return (
        <>
            <h4 className="twm-s-title">Location</h4>
            <div className="twm-m-map mb-5">
                <div className="twm-m-map-iframe">
                    <iframe title="Zozo Jobs Tirupati Job Location Map" height={310} src="https://www.google.com/maps?q=Tirupati&output=embed" />
                </div>
            </div>
        </>
    )
}

export default SectionJobLocation;
